<script setup>
import { onMounted } from 'vue';
import AOS from 'aos';

import HeroSection from '@/components/home/HeroSection.vue';
import WelcomeSection from '@/components/home/WelcomeSection.vue';
import ObjectivesSection from '@/components/home/ObjectivesSection.vue';
import SolutionsSection from '@/components/home/SolutionsSection.vue';
import AboutCeoSection from '@/components/home/AboutCeoSection.vue';
import PartnersSection from '@/components/home/PartnersSection.vue';
import CounterSection from '@/components/home/CounterSection.vue';
import ServicesSection from '@/components/home/ServicesSection.vue';
import TargetCustomersSection from '@/components/home/TargetCustomersSection.vue';
import ExpertiseSection from '@/components/home/ExpertiseSection.vue';
import ImageGallery from "@/components/home/imageGallery.vue";

onMounted(() => {
  AOS.init({
    duration: 800,
    once: true,
  });
});
</script>

<template>
  <main class="home-view">
    <HeroSection />
    <WelcomeSection />
    <ObjectivesSection />
    <SolutionsSection />
    <AboutCeoSection />
    <PartnersSection />
    <CounterSection />
    <ServicesSection />
    <TargetCustomersSection />
    <ExpertiseSection />
    <ImageGallery />
  </main>
</template>

<style>
/* Global styles for the home page sections */
.section-container {
  width: 100%;
  padding: 6rem 5%;
  box-sizing: border-box;
  overflow: hidden;
}

.section-title {
  font-family: 'Poppins', sans-serif;
  font-size: 2.5rem;
  font-weight: 700;
  color: #0A2D61; /* Primary Blue */
  text-align: center;
  margin-bottom: 1rem;
  text-transform: uppercase;
}

.section-subtitle {
  font-family: 'Poppins', sans-serif;
  font-size: 1.1rem;
  color: #555;
  text-align: center;
  max-width: 700px;
  margin: 0 auto 4rem auto;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .section-container {
    padding: 4rem 5%;
  }
  .section-title {
    font-size: 2rem;
  }
  .section-subtitle {
    font-size: 1rem;
    margin-bottom: 3rem;
  }
}
</style>
